/**
 * UUID generation utility with fallback for environments without crypto.randomUUID
 * Addresses compatibility issues with older Android WebViews
 */

/**
 * Generate a UUID v4 with fallback for environments without crypto.randomUUID
 */
export function generateUUID(): string {
  // Use native crypto.randomUUID if available
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  // Fallback using crypto.getRandomValues (widely supported)
  if (typeof crypto !== "undefined" && typeof crypto.getRandomValues === "function") {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
      const randomByte = crypto.getRandomValues(new Uint8Array(1))[0] ?? 0;
      const r = (randomByte & 15) >> (c === "x" ? 0 : 3);
      return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  // Last resort fallback (not cryptographically secure, but functional)
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
}
